document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 1200) {
    document.querySelectorAll('.compare-slider-mobile').forEach(function (sliderEl) {
      try {
        var splide = new Splide(sliderEl, {
          type: 'slide',
          pagination: true,
          arrows: false,
          drag: true,
          gap: '16px',
          perPage: 1.3,
          perMove: 1,
          padding: 0,
          trimSpace: true,
          pagination: false,
          focus: 0,
          breakpoints: {
            1200: {
              fixedWidth: '200px',
              gap: '40px',
              perPage: null,
              trimSpace: true,
            },
          }
        });

        splide.mount();
      } catch (e) {
        console.error('Splide initialization failed:', e);
      }
    });
  }
});

